export const SET_COMPARE_CONTRACTS_PILAR = "SET_COMPARE_CONTRACTS_PILAR";
export function action_setCompareContracts_Pilar(value) {
	return { type: SET_COMPARE_CONTRACTS_PILAR, payload: value };
}

export const SET_COMPARE_CONTRACTS_CONTRATOS = "SET_COMPARE_CONTRACTS_CONTRATOS";
export function action_setCompareContracts_Contratos(value) {
	return { type: SET_COMPARE_CONTRACTS_CONTRATOS, payload: value };
}

export const SET_COMPARE_CONTRACTS_FIRE_GET_DATA = "SET_COMPARE_CONTRACTS_FIRE_GET_DATA";
export function action_setCompareContracts_FireGetData(value) {
	return { type: SET_COMPARE_CONTRACTS_FIRE_GET_DATA, payload: value };
}

export const SET_COMPARE_CONTRACTS_FIRE_EXECUTE_USEEFFECT_AGRUPATION_SERIE_COMPONENT = "SET_COMPARE_CONTRACTS_FIRE_EXECUTE_USEEFFECT_AGRUPATION_SERIE_COMPONENT";
export function action_setCompareContracts_FireExecuteUseEffect_AgrupationSerieComponent(value) {
	return { type: SET_COMPARE_CONTRACTS_FIRE_EXECUTE_USEEFFECT_AGRUPATION_SERIE_COMPONENT, payload: value };
}

export const SET_COMPARE_CONTRACTS_OPF_DATA = "SET_COMPARE_CONTRACTS_OPF_DATA";
export function action_setCompareContracts_OPFData(value) {
	return { type: SET_COMPARE_CONTRACTS_OPF_DATA, payload: value };
}

export const SET_COMPARE_CONTRACTS_CHART_DATA = "SET_COMPARE_CONTRACTS_CHART_DATA";
export function action_setCompareContracts_ChartData(value) {
	return { type: SET_COMPARE_CONTRACTS_CHART_DATA, payload: value };
}

export const SET_COMPARE_CONTRACTS_CHART_DATA_BASE = "SET_COMPARE_CONTRACTS_CHART_DATA_BASE";
export function action_setCompareContracts_ChartDataBase(value) {
	return { type: SET_COMPARE_CONTRACTS_CHART_DATA_BASE, payload: value };
}

export const SET_COMPARE_CONTRACTS_SEGMENT_SELECTED = "SET_COMPARE_CONTRACTS_SEGMENT_SELECTED";
export function action_setCompareContracts_SegmentSelected(value) {
	return { type: SET_COMPARE_CONTRACTS_SEGMENT_SELECTED, payload: value };
}

export const SET_COMPARE_CONTRACTS_CONTRACT_FILTERS = "SET_COMPARE_CONTRACTS_CONTRACT_FILTERS";
export function action_setCompareContracts_ContractFilters(value) {
	return { type: SET_COMPARE_CONTRACTS_CONTRACT_FILTERS, payload: value };
}

export const SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_BASE = "SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_BASE";
export function action_setCompareContracts_ContractFilters_Base(value) {
	return { type: SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_BASE, payload: value };
}

export const SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_SELECTED = "SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_SELECTED";
export function action_setCompareContracts_ContractFilters_Selected(object, field) {
	return { type: SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_SELECTED, payload: {object, field} };
}

export const SET_COMPARE_CONTRACTS_FILTERED_CONTRACTS = "SET_COMPARE_CONTRACTS_FILTERED_CONTRACTS";
export function action_setCompareContracts_Contratos_Filtred(value) {
	return { type: SET_COMPARE_CONTRACTS_FILTERED_CONTRACTS, payload: value };
}

export const SET_COMPARE_CONTRACTS_BASE = "SET_COMPARE_CONTRACTS_BASE";
export function action_setCompareContracts_Contratos_Base(value) {
	return { type: SET_COMPARE_CONTRACTS_BASE, payload: value };
}

export const SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_SELECTED_ALL = "SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_SELECTED_ALL";
export function action_setCompareContracts_ContractFilters_Selected_All(value) {
	return { type: SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_SELECTED_ALL, payload: value };
}

export const SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_CONFIG = "SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_CONFIG";
export function action_setCompareContracts_ContractFilters_Config(value) {
	return { type: SET_COMPARE_CONTRACTS_CONTRACT_FILTERS_CONFIG, payload: value };
}

export const SET_COMPARE_CONTRACTS_CONTRACT_CHARTDATA_STRUCTURE = "SET_COMPARE_CONTRACTS_CONTRACT_CHARTDATA_STRUCTURE";
export function action_setCompareContracts_ChartData_Structure(value) {
	return { type: SET_COMPARE_CONTRACTS_CONTRACT_CHARTDATA_STRUCTURE, payload: value };
}

export const SET_COMPARE_CONTRACTS_CONTRACT_SEGMENT_LIST = "SET_COMPARE_CONTRACTS_CONTRACT_SEGMENT_LIST";
export function action_setCompareContracts_SegmentList(value) {
	return { type: SET_COMPARE_CONTRACTS_CONTRACT_SEGMENT_LIST, payload: value };
}

export const SET_COMPARE_CONTRACTS_CONTRACT_SEGMENT_SCOPE = "SET_COMPARE_CONTRACTS_CONTRACT_SEGMENT_SCOPE";
export function action_setCompareContracts_SegmentScope(value) {
	return { type: SET_COMPARE_CONTRACTS_CONTRACT_SEGMENT_SCOPE, payload: value };
}

export const SET_COMPARE_CONTRACTS_CHART_MAXIMIZED = "SET_COMPARE_CONTRACTS_CHART_MAXIMIZED";
export function action_setCompareContracts_ChartMaximized(value) {
	return { type: SET_COMPARE_CONTRACTS_CHART_MAXIMIZED, payload: value };
}

export const SET_COMPARE_CONTRACTS_PANEL_SEGMENT_VALUES_SELECTED = "SET_COMPARE_CONTRACTS_PANEL_SEGMENT_VALUES_SELECTED";
export function action_setCompareContracts_PanelSegmentValuesSelected(value) {
	return { type: SET_COMPARE_CONTRACTS_PANEL_SEGMENT_VALUES_SELECTED, payload: value };
}

//END BOARD VIEW